import { FileText, Pencil } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function SubscriptionActionIcons({
  onRename,
  onOpenCard,
}: {
  onRename: () => void;
  onOpenCard: () => void;
}) {
  const { t } = useTranslation();
  return (
    <span className="flex shrink-0 items-center gap-0.5">
      <button
        type="button"
        className="grid h-8 w-8 place-items-center rounded-lg text-fg-muted hover:bg-page hover:text-fg"
        title={t('subscriptions.renameTitle')}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onRename();
        }}
      >
        <Pencil className="h-4 w-4" />
      </button>
      <button
        type="button"
        className="grid h-8 w-8 place-items-center rounded-lg text-fg-muted hover:bg-page hover:text-fg"
        title={t('subscriptions.cardTitle')}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onOpenCard();
        }}
      >
        <FileText className="h-4 w-4" />
      </button>
    </span>
  );
}
